import React, { useContext, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import {
  TileRadio, TileRadioGroup,
  GridRow, GridCol, Heading, Checkbox
} from '@lmig/lmds-react';
import TextInput from '../Components/TextInput';
import MapSearch from '../Components/MapSearch';
import axios from 'axios';
import getEnv from '../getEnv';
import { FormContext } from '../FormContext/FormContext';

const Contractor = () => {
  const [selectedValue, setSelectedValue] = useState('');
  const [apiKey, setApiKey] = useState('');
  const [values, handleSetValues, , , setCanContinue, isUsingContractor] = useContext(FormContext);
  const [isPrefilledValue, setIsPrefilledValue] = useState(false);
  const [isCheckedConfirmation, setIsCheckedConfirmation] = isPrefilledValue ? useState(false) : useState(true);

  const getGoogleMapsKey = async () => {
    try {
      const { data } = await axios.get(`${getEnv('API')}/maps/key`);
      setApiKey(data);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('Error fetching Google Maps Api Key', error);
    }
  };

 
  useEffect(() => {
   if (isUsingContractor) {
      setIsCheckedConfirmation(!isPrefilledValue);
     } else {
      if (selectedValue === 'yes' || selectedValue === '') {
        if (values.details.usingContractor.value === 'no') {
          setIsCheckedConfirmation(true);
        } else { 
      setIsCheckedConfirmation(!isPrefilledValue);
      }
      } else {
        setIsCheckedConfirmation(true);
      }
    }
}, [isUsingContractor, selectedValue, isPrefilledValue]);
  
  useEffect(() => {
    const cachedName = localStorage.getItem('contractorName');
    const cachedPhone = localStorage.getItem('contractorPhoneNumber');
    const cachedAddress = localStorage.getItem('contractorAddress');
    const cachedCity = localStorage.getItem('contractorCity');
    const cachedState = localStorage.getItem('contractorState');
    const cachedZip = localStorage.getItem('contractorZipCode');


    const cachedData = cachedName || cachedPhone || cachedAddress || cachedCity || cachedZip || cachedState;
    if (cachedData) {
      setIsPrefilledValue(true);
      setIsCheckedConfirmation(false);
    }
  }, []);

  useEffect(() => {
    setCanContinue(isCheckedConfirmation);
  }, [isCheckedConfirmation, setCanContinue]);

  useEffect(() => {
    if (!apiKey) {
      getGoogleMapsKey();
    }
  }, [apiKey]);

  const handleChange = (event) => {
    const selectedOption = event.target.value;
    setSelectedValue(selectedOption);
    handleSetValues('details', event);
  };

  // const idTitle = isUsingContractor ? 'What is your business Federal Tax ID?' : "What is your contractor's Federal Tax ID?";
  const addressTitle = isUsingContractor ? "Let's help you find your business address" 
  : "Let's help you find your contractor's address";

  return (
    <Box style={{ padding: '20px' }}>
      {isUsingContractor === false && (
        <>
          <Heading type='h3-light' style={{ fontWeight: 300 }}>Are you using a contractor for the repairs?</Heading>

          <TileRadioGroup
            labelVisual=""
            name="usingContractor"
          >
            <GridRow gutters>
              <GridCol base={12} md={4}>
                <TileRadio labelVisual="Yes" defaultChecked={values.details.usingContractor.value === 'yes'} value="yes" 
                onChange={handleChange} />
              </GridCol>
              <GridCol base={12} md={4}>
                <TileRadio labelVisual="No" defaultChecked={values.details.usingContractor.value === 'no'} value="no" 
                onChange={handleChange} />
              </GridCol>
            </GridRow>
          </TileRadioGroup>
        </>
      )}

      {(isUsingContractor === true || selectedValue === 'yes' || values.details.usingContractor.value === 'yes') && (
        <Box>
          {/* <Heading type='h3-light' style={{ marginTop: '64px', fontWeight: 300 }}>{ idTitle }</Heading>

          <GridRow gutters>
            <GridCol base={12} md={4}>
              <TextInput valueKey='contractorTaxId' />
            </GridCol>
          </GridRow> */}

          <Heading type='h3-light' style={{ marginTop: '64px', fontWeight: 300 }}>{ addressTitle }</Heading>

          {apiKey && <MapSearch mapsApiKey={apiKey} />}

          <Heading type='h3-light' style={{ marginTop: '64px', fontWeight: 300 }}>Have we got these details correct?</Heading>

          <GridRow gutters='horizontal'>
            <GridCol base={12} md={8}>
              <TextInput valueKey='contractorName' />
            </GridCol>
          </GridRow>
          <GridRow  gutters='horizontal' >
            <GridCol base={12} md={8}>
              <TextInput valueKey='contractorAddress' />
            </GridCol>
          </GridRow>
          <GridRow gutters='horizontal'>
            <GridCol base={4} md={2}>
              <TextInput valueKey='contractorZipCode' />
            </GridCol>
            <GridCol base={4}  md={3}>
              <TextInput valueKey='contractorCity' />
            </GridCol>
            <GridCol base={4} md={3}>
              <TextInput valueKey='contractorState' />
            </GridCol>
          </GridRow>
          <GridRow gutters='horizontal' >
            <GridCol base={6} md={4}>
              <TextInput valueKey='contractorEmail' />
            </GridCol>
            <GridCol base={6} md={4}>
              <TextInput valueKey='contractorPhoneNumber' />
            </GridCol>
          </GridRow>

          {isPrefilledValue && (
            <Checkbox value='confirmationContractor' checked={isCheckedConfirmation}
              onChange={() => setIsCheckedConfirmation((prev) => !prev)}
              labelVisual='Select if details above are correct' />
          )}
        </Box>
      )}



    </Box>
  );
};


export default Contractor;
